export default {
  en: {
    networkGraph: 'Network graph',
    threatResponses: {
      unanswered: 'Unanswered',
      investigating: 'Investigating',
      remediating: 'Remediating',
      resolved: 'Resolved',
      unaffected: 'Unaffected',
    },
  },
};
